import React, { useState } from "react";
import { downloadFile, errorMessage } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuLabel, DropdownMenuSeparator, DropdownMenuTrigger } from "@/components/ui/dropdown-menu";
import { toast } from "sonner";
import { ChevronDown, Download, Loader2 } from "lucide-react";

/**
 * «Last ned»-meny for Regnskap-rapporter (PDF/CSV).
 * items: [{ key, label, hint?, icon, url, params?, filename, disabled? }] – `separator: true` gir skillelinje.
 */
export const ReportDownloadMenu = ({ items, heading, disabled = false, label = "Last ned", testId = "household-download", align = "end" }) => {
  const [busy, setBusy] = useState(null);
  const run = async (item) => {
    setBusy(item.key);
    try {
      await downloadFile(item.url, item.filename, item.params);
      toast.success(`${item.filename} lastet ned`);
    } catch (e) {
      toast.error(errorMessage(e));
    } finally {
      setBusy(null);
    }
  };
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="outline" disabled={disabled || !!busy} data-testid={`${testId}-button`}>
          {busy ? <Loader2 className="h-4 w-4 mr-2 animate-spin" /> : <Download className="h-4 w-4 mr-2" />}
          {label}
          <ChevronDown className="h-4 w-4 ml-2 opacity-60" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align={align} className="w-72" data-testid={`${testId}-menu`}>
        {heading ? <DropdownMenuLabel className="text-xs uppercase tracking-wide text-muted-foreground font-medium">{heading}</DropdownMenuLabel> : null}
        {items.map((it, i) => (it.separator ? <DropdownMenuSeparator key={`sep-${i}`} /> : (
          <DropdownMenuItem key={it.key} disabled={it.disabled || busy === it.key} onSelect={() => run(it)} className="items-start gap-3 py-2" data-testid={`${testId}-${it.key}`}>
            {it.icon ? <it.icon className="h-4 w-4 mt-0.5 text-muted-foreground shrink-0" /> : null}
            <span className="min-w-0">
              <span className="block text-sm font-medium">{it.label}</span>
              {it.hint ? <span className="block text-xs text-muted-foreground">{it.hint}</span> : null}
            </span>
          </DropdownMenuItem>
        )))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
